import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const PopoverContentStyled = styled(Box)({
  width: '420px',
  padding: '16px 16px 0 16px',
  boxSizing: 'border-box',
});
